import { useEffect, useRef } from 'react';

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    if (ref.current !== value) {
      ref.current = value;
    }
  }, [value]);
  return ref.current;
}

export default usePrevious;
